import { useEffect, useState } from 'react'

export type PresenceState = 'open' | 'closed'

// Keeps a panel mounted long enough to play its closing animation.
export const usePresence = (open: boolean, exitMs = 320): { mounted: boolean, state: PresenceState } => {
    const [mounted, setMounted] = useState(open)
    const [state, setState] = useState<PresenceState>(open ? 'open' : 'closed')

    useEffect(() => {
        if (open) {
            setMounted(true)
            setState('open')

            return
        }

        setState('closed')

        const timeout = window.setTimeout(() => setMounted(false), exitMs)

        return () => window.clearTimeout(timeout)
    }, [open, exitMs])

    return { mounted, state }
}
